/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import SetPassword from '../../components/auth/SetPassword';
import RequestCode from '../../components/auth/RequestCode';
import {useRoutingUtils} from '../RoutingUtils';
import {PasswordFlow} from '../../components/auth/types';
import Terms from '../../pages/terms/Terms';
import useAppStore from '../../hooks/useAppStore';
import {useFoqalRouteTrack} from '../../hooks/useFoqal';
import {SignIn as SignInPage} from '../../pages/auth/SignIn';
import {LoginCallback} from "../../pages/auth/LoginCallback";
import "../../components/auth/SignIn.scss";

export interface SignInRouteProps {
    signedIn?: () => void
}
export const SignInRoute: React.FC<SignInRouteProps> =
    (params: SignInRouteProps) =>
        <Router>
            <Contents {...params}></Contents>
        </Router>;

// https://github.com/ReactTraining/react-router/issues/7015
// You can't use any of the hooks (useHistory, @rackuka)
// from within the same component that puts the Router into the tree.
// You need to move your BrowserRouter out of that component.
// It can go in the ReactDOM.render() call, for instance.
const Contents: React.FC<SignInRouteProps> = () => {
    useFoqalRouteTrack();

    const { goto, goback } = useRoutingUtils();
    const appStore = useAppStore();

    React.useEffect(()=> {
        appStore.set({isLoading: false});
        return ()=> {};
    }, []);


    return (
        <Switch>
            <Route exact path="/login" component={() =>
                <SignInPage />
            }
            />
            <Route exact path="/loginCallback">
                <LoginCallback />
            </Route>
            <Route path="/login/forgot" component={() =>
                <RequestCode
                    cancelled={goback}
                    needResetPassword={goto('/login/enter-password')}
                />
            }/>
             <Route exact path="/login/enter-password" component={() =>
                <SetPassword
                    toLogin={goto("/login")}
                    needSignIn={goto('/')}
                    flow={PasswordFlow.RESET}
                />
            }/>
            <Route path="/terms" component={Terms}/>
            <Route path="/">
                <Redirect to="/login" />
            </Route>
        </Switch>
    );
};

